import React from 'react';
import { FiltersTypes } from '@monorepo/common';
import { useFilter } from '@monorepo/helpers';
import { FILTER_PARAMS } from '@monorepo/dictionary';
import useGetTypes from '../../hooks/useGetTypes';

type TProps = {
  config: {
    isShowAll: boolean;
    defaultType: string | undefined;
  };
};

const TypesFilter: Component<TProps> = ({ config }) => {
  const { isShowAll = false, defaultType } = config;
  // const { t } = useI18n();
  const { filter } = useFilter();
  const { data, isFetching } = useGetTypes({
    grouping: null,
    filter,
    active: FILTER_PARAMS.typeId
  });

  // const productTypesEnum = prepareOptions(
  //   // @ts-ignore
  //   enumToSelectOptions(PRODUCT_TYPES),
  //   t,
  //   'productTypes.'
  // );

  // const types = enumToTabs(productTypesEnum, data);

  if (!isFetching && !data) {
    return null;
  }

  return (
    <FiltersTypes data={data} defaultType={defaultType} isShowAll={isShowAll} />
  );
};

export default TypesFilter;
